// extracted by mini-css-extract-plugin
module.exports = {"header":"post-list_header__3jFi7","notfound":"post-list_notfound__3wl7E"};